import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './cnc.css'

const CNC = (props) => {
  return (
    <div className="cnc-container">
      <Helmet>
        <title>Промышленный робот для загрузки станков ЧПУ | Arcobo</title>
        <meta
          name="description"
          content="Роботизация станков ЧПУ для токарных и фрезерных центров. Внедрение РТК под ключ, повышение коэффициента загрузки оборудования и работа 24/7."
        />
        <meta
          property="og:title"
          content="Промышленный робот для загрузки станков ЧПУ | Arcobo"
        />
        <meta
          property="og:description"
          content="Роботизация станков ЧПУ для токарных и фрезерных центров. Внедрение РТК под ключ, повышение коэффициента загрузки оборудования и работа 24/7."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Промышленный робот для загрузки станков ЧПУ | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Роботизация станков ЧПУ для токарных и фрезерных центров. Внедрение РТК под ключ, повышение коэффициента загрузки оборудования и работа 24/7."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/cnc"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/cnc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"CNC","item":"https://arcobo.tech/cnc"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name15"></HeaderMain>
      <hr className="cnc-separator1"></hr>
      <Componenttextimage
        image1Src="/0_Main_page/Solution/cnc_13-1500w.webp"
        image1Alt="Обслуживание станков ЧПУ"
        rootClassName="componenttextimageroot-class-name3"
        textComponent={
          <Fragment>
            <span className="cnc-text100">
              <span className="cnc-text101 H1_extrasmall">
                Автоматизированные комплексы для загрузки, выгрузки и
                обслуживания металлообрабатывающих станков
              </span>
              <br></br>
              <span className="text_large">
                Роботизированные комплексы Arcobo обеспечивают автоматическую
                загрузку и выгрузку деталей, обслуживание одного или нескольких
                станков ЧПУ, а также интеграцию с измерительными и складскими
                системами. Решение позволяет организовать непрерывную работу
                оборудования, повысить производительность и сократить влияние
                человеческого фактора.
              </span>
              <br></br>
              <br></br>
              <span className="cnc-text106 H1_medium">
                Преимущества и выгоды:
              </span>
              <br></br>
              <span className="cnc-text108">✔ </span>
              <span className="cnc-text109 H1_extrasmall">
                Максимальная загрузка оборудования
              </span>
              <br></br>
              <span>
                Робот обеспечивает стабильную работу станков без простоев между
                циклами обработки и позволяет эффективно использовать
                дорогостоящее оборудование.
              </span>
              <br></br>
              <span className="cnc-text113">✔ </span>
              <span className="cnc-text114 H1_extrasmall">Работа 24/7</span>
              <br></br>
              <span>
                Комплекс способен обслуживать станки в автоматическом режиме,
                включая ночные смены и выходные дни, без снижения качества
                работы.
              </span>
              <br></br>
              <span className="cnc-text118">✔ </span>
              <span className="cnc-text119 H1_extrasmall">
                Обслуживание нескольких станков
              </span>
              <br></br>
              <span>
                Один робот может последовательно обслуживать несколько станков
                ЧПУ, снижая капитальные затраты на автоматизацию.
              </span>
              <br></br>
              <span className="cnc-text123">✔ </span>
              <span className="cnc-text124 H1_extrasmall">
                Простая интеграция
              </span>
              <br></br>
              <span>
                Комплекс интегрируется с существующими станками, системами
                хранения заготовок, измерительными станциями и MES/ERP
                предприятия.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Обслуживание станков ЧПУ"
      ></Componenttextimage>
      <Component3images
        image1Src="/1_Solution/1_1_3_CNC/201_cnc-200h.webp"
        image1Alt="Обслуживание станков ЧПУ"
        image2Src="/1_Solution/1_1_3_CNC/202_cnc-200h.webp"
        image2Alt="Обслуживание станков ЧПУ"
        image3Src="/1_Solution/1_1_3_CNC/203_cnc-200h.webp"
        image3Alt="Обслуживание станков ЧПУ"
        rootClassName="component3imagesroot-class-name6"
      ></Component3images>
      <hr className="cnc-separator2"></hr>
      <Componentparameters
        text1={
          <Fragment>
            <span className="cnc-text127">
              <span className="cnc-text128">•</span>
              <span> Промышленный робот-манипулятор</span>
              <br></br>
              <span className="cnc-text131">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Захват под детали заказчика</span>
              <br></br>
              <span className="cnc-text135">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система автоматической загрузки и выгрузки</span>
              <br></br>
              <span className="cnc-text139">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроллер управления роботизированной ячейкой</span>
              <br></br>
              <span className="cnc-text143">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программное обеспечение Arcobo</span>
              <br></br>
              <span className="cnc-text147">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Защитное ограждение с системой безопасности</span>
              <br></br>
              <span className="cnc-text151">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Интерфейс обмена со станком • ЧПУ</span>
              <br></br>
              <span className="cnc-text155">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="cnc-text158">
              <span>
                Количество обслуживаемых станков:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="cnc-text160">до 6</span>
              <br></br>
              <span>
                Режим работы:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="cnc-text163">24/7</span>
              <br></br>
              <span>Тип обслуживаемых деталей:</span>
              <span className="cnc-text166"> по техническому заданию</span>
              <br></br>
              <span>Интеграция со станками:</span>
              <span className="cnc-text169">Да</span>
              <br></br>
              <span>Контроль наличия деталей:</span>
              <span className="cnc-text172">Да</span>
              <br></br>
              <span>
                Автоматическая смена захватов:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="cnc-text175">Опция</span>
              <br></br>
              <span>Интеграция с MES/ERP:</span>
              <span className="cnc-text178">Опция</span>
              <br></br>
              <span>
                Онлайн-мониторинг:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="cnc-text181">Опция</span>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="cnc-text182">
              <span className="cnc-text183">•</span>
              <span> Анализ производственного процесса</span>
              <br></br>
              <span className="cnc-text186">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Проектирование роботизированной ячейки</span>
              <br></br>
              <span className="cnc-text189">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Изготовление оснастки и захватов</span>
              <br></br>
              <span className="cnc-text192">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программирование комплекса</span>
              <br></br>
              <span className="cnc-text196">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
              <br></br>
              <span className="cnc-text200">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Обучение операторов и технического персонала</span>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="cnc-text203">
              <span className="cnc-text204">•</span>
              <span> Линейная ось для обслуживания нескольких станков</span>
              <br></br>
              <span className="cnc-text207">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система машинного зрения</span>
              <br></br>
              <span className="cnc-text211">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Автоматическая смена захватов</span>
              <br></br>
              <span className="cnc-text215">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Накопители заготовок</span>
              <br></br>
              <span className="cnc-text219">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроль качества деталей</span>
              <br></br>
              <span className="cnc-text223">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Автоматическая маркировка изделий</span>
              <br></br>
              <span className="cnc-text226">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Интеграция с ERP и MES</span>
              <br></br>
              <span className="cnc-text230">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Индивидуальная оснастка под детали заказчика</span>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="cnc-text233">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        heading1="A. Базовая комплектация"
        heading2="B. Возможности комплекса"
        heading3="C. В состав поставки включены:"
        heading4="D. Дополнительные опции"
        showDiv5={false}
        mainHeading="Характеристики базовой ячейки"
        rootClassName="componentparametersroot-class-name3"
      ></Componentparameters>
      <Component3images
        image1Src="/1_Solution/1_1_3_CNC/204_cnc-200h.webp"
        image1Alt="Сервис станков ЧПУ"
        image2Src="/1_Solution/1_1_3_CNC/205_cnc-200h.webp"
        image2Alt="Сервис станков ЧПУ"
        image3Src="/1_Solution/1_1_3_CNC/206_cnc-200h.webp"
        image3Alt="Сервис станков ЧПУ"
        rootClassName="component3imagesroot-class-name7"
      ></Component3images>
      <hr className="cnc-separator3"></hr>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="cnc-text234">
              Комплекс совместим с большинством современных токарных, фрезерных
              и многофункциональных станков ЧПУ независимо от производителя.
              Конфигурация подбирается индивидуально под оборудование и
              технологический процесс предприятия.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="cnc-text235">
              Наибольший эффект достигается при серийном производстве,
              многосменной работе, дефиците операторов и необходимости
              обеспечить стабильную загрузку дорогостоящего оборудования.
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="cnc-text236">
              <span>
                В зависимости от времени цикла, расположения оборудования и
                массы деталей один робот может обслуживать несколько станков ЧПУ
                одновременно. Конфигурация комплекса определяется после анализа
                производственного процесса.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="cnc-text239">
              <span>
                Помимо загрузки и выгрузки деталей робот может выполнять
                продувку, очистку, контроль качества, маркировку, перекладку
                изделий, укладку на паллеты и взаимодействие с
                автоматизированными складами.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="cnc-text242">
              <span>
                Да. Большинство проектов Arcobo реализуются на действующих
                производственных линиях без необходимости замены станков.
                Роботизированный комплекс интегрируется в существующую
                инфраструктуру предприятия с минимальными изменениями.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="cnc-text245">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="cnc-text246">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="cnc-text247">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие станки можно автоматизировать?"
        question2="Когда роботизация обслуживания ЧПУ наиболее эффективна?"
        question3="Сколько станков может обслуживать один робот?"
        question4="Какие операции выполняет робот?"
        question5="Совместим ли комплекс с уже существующим производством?"
        rootClassName="componentfaqroot-class-name3"
      ></Componentfaq>
      <hr className="cnc-separator4"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name15"></FooterMain>
    </div>
  )
}

export default CNC
